export default {"src":"/_next/static/media/pharmacy-rx.d695aa70.svg","height":344,"width":344,"blurWidth":0,"blurHeight":0};